import { ulid } from 'ulid'
import { kvGet, kvSet } from './db'

let cached: string | undefined

/** A stable id for this install, used to order conflicting edits and tag sessions. */
export async function deviceId(): Promise<string> {
  if (cached) return cached
  let id = await kvGet<string>('deviceId')
  if (!id) {
    id = `dev-${ulid().toLowerCase()}`
    await kvSet('deviceId', id)
  }
  cached = id
  return id
}

export function resetDeviceIdCache() {
  cached = undefined
}

/** A fresh id, for a phone the parent unlinked (its old id can't join again). */
export async function newDeviceId(): Promise<string> {
  cached = `dev-${ulid().toLowerCase()}`
  await kvSet('deviceId', cached)
  return cached
}

/** A name for this phone in the parent's Phones list ("Pixel 7 Pro"), where the browser says. */
export async function deviceLabel(): Promise<string> {
  type UAData = { mobile?: boolean; getHighEntropyValues?(h: string[]): Promise<{ model?: string }> }
  const ua = (navigator as Navigator & { userAgentData?: UAData }).userAgentData
  const model = await ua?.getHighEntropyValues?.(['model']).then((v) => v.model?.trim()).catch(() => undefined)
  if (model) return model.slice(0, 40)
  if (/Android/i.test(navigator.userAgent)) return 'Android phone'
  if (/iPhone|iPad/i.test(navigator.userAgent)) return 'iPhone'
  return 'Computer'
}
